<template>
    <main-content>
        <div class="bg-white p-3 rounded shadow-sm">
            <ul class="nav nav-tabs mb-4">
                    <li class="nav-item" v-if="!is_direct_settlement">
                        <router-link :class="['nav-link', tab == 'gateway-form' ? 'active':'']" data-toggle="tab" :to="`/settlement-settings/ipg/${hashid}/gateway-form`" role="tab" :aria-selected="tab == 'gateway-form'">
                            {{ $t('label.settlement_schedule') }}
                        </router-link>
                    </li>
                    <li class="nav-item">
                        <router-link :class="['nav-link', tab == 'changes-requests' ? 'active':'']" data-toggle="tab" :to="`/settlement-settings/ipg/${hashid}/changes-requests`" role="tab" :aria-selected="tab == 'changes-requests'">
                            {{ $t('label.add_sheba_to_gateway') }}
                        </router-link>
                    </li>
                    <li class="nav-item" v-if="show_enamad_tab">
                        <router-link :class="['nav-link', tab == 'register-enamad' ? 'active':'']" data-toggle="tab" :to="`/settlement-settings/ipg/${hashid}/register-enamad`" role="tab" :aria-selected="tab == 'register-enamad'">
                            {{ $t('label.enamad_register') }}
                        </router-link>
                    </li>
                    <li class="nav-item">
                        <router-link :class="['nav-link', $route.name == 'gateways_allotment' ? 'active' : '']" :to="`/gateways/${hashid}/allotment`">{{ $t('allotment.settlement_sheba') }}</router-link>
                    </li>
                    <li class="nav-item" v-if="!is_direct_settlement">
                        <router-link :class="['nav-link', $route.name == 'gateway_stakeholders_list' ? 'active' : '']" :to="`/gateways/stakeholders/${hashid}`">{{ $t('stakeholders.label.shop_stakeholders_list') }}</router-link>
                    </li>
                    <li class="nav-item" v-if="show_stakeholders_tab">
                        <router-link :class="['nav-link', $route.name == 'stakeholders_get' && $route.query.gateway_hashid == hashid ? 'active' : '']" :to="`/stakeholders?gateway_hashid=${hashid}`">{{ $t('stakeholders.label.manage_stakeholders') }}</router-link>
                    </li>
            </ul>
            <slot></slot>
        </div>
    </main-content>
</template>

<script>
import mainContent from '@/components/main-content.vue';
import { mapGetters } from 'vuex';
import { shopType } from '@/constants/ShopType';

export default {
    components: {
        mainContent,
    },
    computed: {
        hashid() {
            return this.$route.params.hashid;
        },
        is_direct_settlement() {
            return !!this.form_data && this.form_data.type === shopType.BUSINESS_PSP_SETTLEMENT;
        },
        tab() {
            const isSettlementRoute = this.$route.path.startsWith('/settlement-settings/ipg/');
            return isSettlementRoute ? (this.$route.params.type || 'gateway-form') : '';
        },
        ...mapGetters('gateway', [
            'form_data', 'status'
        ]),
        show_enamad_tab() {
            return false;
        },
        show_stakeholders_tab() {
            return this.form_data && this.form_data.gateway_type === 0 && this.form_data.type === 2;
        }
    },
    mounted() {
        if (this.hashid && (this.$route.name === 'gateways_allotment' || this.$route.name === 'gateway_stakeholders_list')) {
            this.loadGatewayData();
        }
    },
    watch: {
        '$route.params.hashid'(newHashid, oldHashid) {
            if (newHashid && newHashid !== oldHashid && (this.$route.name === 'gateways_allotment' || this.$route.name === 'gateway_stakeholders_list')) {
                this.loadGatewayData();
            }
        }
    },
    methods: {
        loadGatewayData() {
            if (!this.hashid) {
                return;
            }
            this.$store.dispatch('gateway/find', this.hashid).catch(({ response }) => {
                console.error('Failed to load gateway data:', response);
            });
        }
    }
}
</script>
